import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import VerifyAccount from "./VerifyAccount";
import LayoutManager from "../Common/LayoutManager";
import CreateAccountScreen from "./CreateAccountScreen";
import { LayoutDesktop, LayoutCenterContent } from "../Common/Layout";

import { useLogin } from "../../utils/auth";
import { Items, removeState } from "../../redux/storePersist";

function CreateAccount() {
  const navigate = useNavigate();
  const location = useLocation();

  const [showVerify, setShowVerify] = useState(false);

  const { isLoading, userExists, profile, auth0 } = useLogin();

  const qs = new URLSearchParams(location.search.slice(1));
  const redirectUri = qs.get("next") || "/";

  const goToSignIn = async () => {
    removeState(Items.GTM_STATE);
    return await auth0.logout({
      logoutParams: { returnTo: window.location.origin },
    });
  };

  useEffect(() => {
    if (profile.sub && !profile.email_verified) setShowVerify(true);

    if (userExists) navigate(redirectUri);
  }, [profile, userExists, redirectUri, navigate]);

  if (userExists) {
    return (
      <>
        <p>User already exists.</p>
        <p>Redirecting to homepage...</p>
      </>
    );
  }

  if (isLoading)
    return (
      <div className="w-full font-bold text-center">
        <p>Loading...</p>
      </div>
    );

  return (
    <LayoutManager showHeader={false}>
      <LayoutDesktop height="min-h-screen-footer">
        {!showVerify ? (
          <LayoutCenterContent className="shadow-lg">
            <CreateAccountScreen
              profile={profile}
              goToSignIn={goToSignIn}
              redirectUri={redirectUri}
            />
          </LayoutCenterContent>
        ) : (
          <LayoutCenterContent className="shadow-lg relative overflow-hidden">
            <VerifyAccount />
          </LayoutCenterContent>
        )}
      </LayoutDesktop>
    </LayoutManager>
  );
}

export default CreateAccount;
